import { Tables } from "@/supabase/types";
import { ChatMessageContent, ChatMessagePart } from "@/types/base";

export type MessagePayload = {
 role: string
 content: ChatMessageContent
}

/**
 * Get the role from the last message in the payload
 * @param message
 * @returns
 */
export const getLastRole = (message: Tables<"messages">) => {
	const payload = message.payload as MessagePayload[]
	return payload.length > 0 ? payload[payload.length -1].role : ''
}

/**
 * Get the role from the first message in the payload
 * @param message
 * @returns
 */
export const getTopRole = (message: Tables<"messages">) => {
	const payload = message.payload as MessagePayload[]
	return payload.length > 0 ? payload[0].role : ''
}

/**
 * Get the first content of the last message in the payload
 * @param message
 * @returns
 */
export const getLastContent = (message: Tables<"messages">) => {
	const payload = message.payload as MessagePayload[]
	return payload.length > 0 ? firstContent(payload[payload.length -1].content, '') : ''
}

/**
 * Get the string from the first content of the last message in the payload
 * @param message
 * @returns
 */
export const getLastContentString = (message: Tables<"messages">) => {
	// const lastContent = getLastContent(message)
	// return extractText(lastContent)
	return message.content
}

/**
 * Get the first content of the first message in the payload
 * @param message
 * @returns
 */
export const getTopContent = (message: Tables<"messages">) => {
	const payload = message.payload as MessagePayload[]
	return payload.length > 0 ? firstContent(payload[0].content, '') : ''
}

/**
 * Get the string from the first content of the first message in the payload
 * @param message
 * @returns
 */
export const getTopContentString = (message: Tables<"messages">) => {
	// const topContent = getTopContent(message)
	// return extractText(topContent)
	return message.content
}

export function normalizeContent(content: ChatMessagePart[]): ChatMessageContent {
	return content.length === 1 && 'text' in content[0]
		? content[0].text
		: content
}

// export function extractFirstText(content: ChatMessageContent): string | undefined {
// 	if (typeof content === 'string') return content

// 	for (const part of content) {
// 		if ('text' in part && typeof part.text === 'string') return part.text
// 	}
// }

type ChatMessagePartWithText = Extract<ChatMessagePart, { text: string }>

const hasText = (part: ChatMessagePart): part is ChatMessagePartWithText =>
	typeof (part as any).text === 'string'

export const extractText = (input: string | ChatMessagePart): string =>
	typeof input === 'string'
		? input
		: hasText(input)
			? input.text
			: ''

export const firstContent = (
	content: ChatMessageContent,
	fallback: ChatMessagePart | string
): ChatMessagePart | string =>
	Array.isArray(content) && content.length
		? content[0]
		: typeof content === 'string'
			? content
			: fallback

export const lastContent = (
	content: ChatMessageContent,
	fallback: ChatMessagePart | string
): ChatMessagePart | string =>
	Array.isArray(content) && content.length
		? content[content.length - 1]
		: typeof content === 'string'
			? content
			: fallback


export type ToolCallExtract = {
  toolName: string
  toolCallId: string
  input: unknown
}

type ToolCallPartV4 = {
  type: 'tool-call'
  toolCallId: string
  toolName: string
  args: unknown
}

type ToolCallPartV5 = {
  type: 'tool-call'
  toolCallId: string
  toolName: string
  input: unknown
}

type ContentPart = ToolCallPartV4 | ToolCallPartV5 | { type: string; [k: string]: unknown }

type PayloadEntry = {
  id: string
  role: string
  content: ContentPart[]
}

export type Payload = PayloadEntry | PayloadEntry[]

export function extractAssistantToolCalls(payload: Payload): ToolCallExtract[] {
  const entries = Array.isArray(payload) ? payload : [payload]
  return entries
    .filter(entry => entry.role === 'assistant')
    .flatMap(entry =>
      (Array.isArray(entry.content) ? entry.content : [])
        .filter(part => part.type === 'tool-call')
        .map(part => {
          const toolName = (part as any).toolName
          const toolCallId = (part as any).toolCallId
          const input =
            'input' in part
              ? (part as ToolCallPartV5).input
              : 'args' in part
                ? (part as ToolCallPartV4).args
                : undefined
          return { toolName, toolCallId, input }
        })
        .filter(tc => tc.toolName && tc.toolCallId)
    )
}